import { CRUDActions } from "../enums/CRUDActions";

export class GCItem
{
  constructor(data: GCItem = null) {
    if (data != null) {
      this.description = data.description;
        this.value = data.value;
        this.reference = data.reference;
        this.category = data.category;
        this.action = data.action;
        this.fullContract = data.fullContract;
    }
  }
    description: string;
    value: any;
    reference: any;
    category: any;
    action: CRUDActions;
    fullContract: boolean;
}
